import { ForgotPassHandlerPropsT } from "../../Types";
import { Axios } from "../../Config";

export const ForgotPassHandler = async (params: ForgotPassHandlerPropsT) => {
  return Axios.get("/users/reset-password", { params });
};
